import { TDataGridSettings } from "src/components/datagrid-with-identity/datagrid-with-identity-types";

// Order-significant: also drives on-screen chip order, not just which items are selected.
export type TConfiguratorViewSettings = { selectedItemIds: string[] };

export type TIdentitySettings = {
  [IDENTITY_SETTINGS_KEYS.PRODUCT_VIEW]: string;
  [IDENTITY_SETTINGS_KEYS.PRICE_LIST_DATA_GRID]: TDataGridSettings;
  [IDENTITY_SETTINGS_KEYS.CREDIT_NOTE_DATA_GRID]: TDataGridSettings;
  [IDENTITY_SETTINGS_KEYS.INVOICE_HISTORY_DATA_GRID]: TDataGridSettings;
  [IDENTITY_SETTINGS_KEYS.INVOICE_LINE_DATA_GRID]: TDataGridSettings;
  [IDENTITY_SETTINGS_KEYS.USER_MANAGEMENT_DATA_GRID]: TDataGridSettings;
  [IDENTITY_SETTINGS_KEYS.PROJECT_LIST_DATA_GRID]: TDataGridSettings;
  [IDENTITY_SETTINGS_KEYS.CONFIGURATOR_VIEW_SETTINGS]: TConfiguratorViewSettings;
};

export enum IDENTITY_SETTINGS_KEYS {
  PRODUCT_VIEW = "PRODUCT_VIEW",
  PRICE_LIST_DATA_GRID = "PRICE_LIST_DATA_GRID",
  CREDIT_NOTE_DATA_GRID = "CREDIT_NOTE_DATA_GRID",
  INVOICE_HISTORY_DATA_GRID = "INVOICE_HISTORY_DATA_GRID",
  INVOICE_LINE_DATA_GRID = "INVOICE_LINE_DATA_GRID",
  USER_MANAGEMENT_DATA_GRID = "USER_MANAGEMENT_DATA_GRID",
  PROJECT_LIST_DATA_GRID = "PROJECT_LIST_DATA_GRID",
  CONFIGURATOR_VIEW_SETTINGS = "CONFIGURATOR_VIEW_SETTINGS"
}
